import { NgModule } from '@angular/core';
import { MainServicesComponent} from "./components/main-services.component";
import { MainServiceComponent} from "./components/main-service.component";
import { MainNewServiceComponent} from "./components/main-newService.component";
import { SearchServicesComponent} from "./components/dummy/search-services.component";
import { DataServiceComponent} from "./components/dummy/data-service.component";
import { UserServiceComponent} from "./components/dummy/user-service.component";
import { CommentsServiceComponent} from "./components/dummy/comments-service.component";
import { ListServicesComponent} from "./components/dummy/list-services.component";
import { ServicesServiceComponent} from "./components/dummy/services-service.component";
import { AssignServiceComponent} from "./components/dummy/assign-service.component";
import { CleanerServiceComponent} from "./components/dummy/cleaner-service.component";
import { SelectOfficeServiceComponent} from "./components/dummy/selectOffice-service.component";
import { NewDataServiceComponent} from "./components/dummy/newData-service.component";
import { HeaderServiceComponent} from "./components/dummy/header-service.component";
import { AddressServiceComponent} from "./components/dummy/address-service.component";
import { SelectAddressServiceComponent} from "./components/dummy/selectAddress-service.component";
import { CommonModule } from '@angular/common';
import { ServicesRoutes } from './services.routes';
import { JsonpModule, HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ServicesService } from "../../injections/services.service";
import { ServiceService } from "../../injections/service.service";
import { UsersService } from "../../injections/users.service";
import { UserService } from "../../injections/user.service";
import { SettingsService } from "../../injections/settings.service";
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { ModalCancelComponent } from './components/dummy/modal-cancel.component';
import {SharedModule} from "../../common/shared.module";
import { ModalRecurrencyComponent } from './components/dummy/modal-recurrency.component';
import { ModalAssignComponent } from './components/dummy/modal-assign.component';

@NgModule({
    imports: [CommonModule,
    ServicesRoutes,
    JsonpModule,
    FormsModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    SharedModule,
    HttpModule],
    exports: [],
    declarations: [
        MainServicesComponent, MainServiceComponent, SearchServicesComponent, ListServicesComponent, DataServiceComponent, UserServiceComponent, 
        CommentsServiceComponent, ServicesServiceComponent, AssignServiceComponent, CleanerServiceComponent, ModalCancelComponent, MainNewServiceComponent, 
        SelectOfficeServiceComponent, NewDataServiceComponent, HeaderServiceComponent, AddressServiceComponent, SelectAddressServiceComponent, 
        ModalRecurrencyComponent, ModalAssignComponent
    ],
    providers: [ServicesService, ServiceService, UsersService, SettingsService, UserService],
})

export class ServicesModule { }



// WEBPACK FOOTER //
// ./src/app/modules/services/services.module.ts